/** Hugging Face 集成契约；只接受官方路由或专用推理端点 HTTPS 地址，Token 明文只提交不回显。 */
import { z } from 'zod';

/** Inference Providers 统一路由（serverless，按用量计费）的 OpenAI 兼容基址。 */
export const HUGGINGFACE_ROUTER_BASE_URL = 'https://router.huggingface.co/v1';

export const HuggingFaceBaseUrlSchema = z
  .string()
  .trim()
  .max(512)
  .regex(
    // 路由地址精确匹配；专用端点为 <endpoint-id>.<region>.<cloud>.endpoints.huggingface.cloud。
    /^https:\/\/(?:router\.huggingface\.co|[a-z0-9]+\.[a-z0-9-]+\.(?:aws|gcp|azure)\.endpoints\.huggingface\.cloud)\/v1$/,
    '请输入 Hugging Face 官方 HTTPS 地址（Inference Providers 路由或专用推理端点，以 /v1 结尾）',
  );

export const UpsertHuggingFaceCredentialRequestSchema = z
  .object({
    base_url: HuggingFaceBaseUrlSchema,
    api_key: z
      .string()
      .trim()
      .min(8, 'Hugging Face Token 至少 8 个字符')
      .max(512, 'Hugging Face Token 不能超过 512 个字符')
      .optional(),
    timeout_seconds: z
      .number()
      .int('请求超时须为整数秒')
      .min(30, '请求超时须在 30–120 秒之间')
      .max(120, '请求超时须在 30–120 秒之间')
      .default(60),
  })
  .strict();
export type UpsertHuggingFaceCredentialRequest = z.input<
  typeof UpsertHuggingFaceCredentialRequestSchema
>;
export type HuggingFaceCredentialResponse = {
  configured: boolean;
  base_url: string | null;
  key_tail: string | null;
  timeout_seconds: number | null;
  last_verified_at: string | null;
  updated_at: string | null;
};
